//{}
import {
  create_customer,
  update_customer,
  delete_customer,
  recover_customer,
  query_customer_list,
} from '@/api/mjstore-model';

import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model/mjstore/mjstore-customer-config';
import column_config from '@/components/page-model/mjstore/mjstore-customer-column-config';
import edit_config from '@/components/page-model/mjstore/mjstore-customer-edit-config';
import update_config from '@/components/page-model/mjstore/mjstore-customer-update-config';

import { onMounted, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import mitt from 'mitt';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
  const { baseColumns, newSlotList } = column_config(current_org);
  const { edit_model_config, edit_model_config_options } = edit_config(current_org, current_shop);
  const { update_model_config, update_model_config_options } = update_config(
    current_org,
    current_shop,
  );

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'search_text',
        label: '模糊搜索',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写搜索内容',
      },
      {
        type: 'input',
        name: 'name',
        label: '会员姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员姓名',
      },
      {
        type: 'input',
        name: 'phone',
        label: '手机',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写手机',
      },

      {
        type: 'input',
        name: 'code',
        label: '会员编号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员编号',
      },
      {
        type: 'remoteselect',
        name: 'query_shop_id',
        label: '会籍门店',
        disabled: false,
        placeholder: '请选择会籍门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'adviser_id',
        label: '所属顾问',
        disabled: false,
        placeholder: '请选择所属顾问',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      query_shop_id: null,
      is_active: true,
      name: null,
      phone: null,
      shop_id: current_shop?.id,
      adviser_id: null,
      code: null,
    }),
  };
  const search_options = {
    is_active: [
      { value: None, name: '全部' },
      { value: True, name: '可用' },
      { value: False, name: '作废' },
    ],
  };

  const titleList = {
    title: '会员管理',
    addModalTitle: '新建',
    updateTitle: '修改',
    is_create: true, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      customer_id: 'id',
    },
    delete: {
      customer_id: 'id',
    },
    recover: {
      customer_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      customer_id: 'id',
    },
  };

  const route = useRoute();
  search_config.model.search_text = route.query.q;
  // if (route.path == '/business_manage/mjstore-customer' && route.query.q) {
  // search_config.model.search_text = route.query.q;
  // event_obj.emit('refresh_search', { search_text: route.query.q, shop_id: null });
  // }
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_customer_list,
    addData: create_customer,
    updateData: update_customer,
    removeData: delete_customer,
    recoverData: recover_customer,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
